export default "__VITE_PUBLIC_ASSET__506945f6__"